import { queryKeys } from '@query/keys'
import { useQuery } from '@tanstack/react-query'

import { useAccountReadContext } from '@context/AccountContextContext'

import { useApiClient } from '@utils/ApiClient'
import { ClientApiClient } from '@utils/clientApi'

import { NameDto } from '@model/NameDto'

export interface IBTradingAccountsRebatesFilterOptions {
  accountTypes?: NameDto[]
  tradingAccounts?: NameDto<string>[]
  clients?: NameDto<string>[]
  groups?: NameDto<string>[]
  countries?: NameDto<string>[]
}

export const useIBTradingAccountsRebatesFilterOptions =
  (): IBTradingAccountsRebatesFilterOptions => {
    const apiClient = useApiClient(ClientApiClient)
    const { account } = useAccountReadContext()

    const ibId = account?.clientIntroducingBroker?.id

    const { data } = useQuery({
      queryKey: queryKeys.ib.rebates.clientsFilterOptions(ibId),
      queryFn: () => apiClient.getIBTradingAccountsRebatesFilterOptions(ibId!),
      enabled: !!ibId,
      staleTime: 5 * 60_000,
    })

    return {
      accountTypes: data?.accountTypes || [],
      tradingAccounts: data?.tradingAccounts || [],
      clients: data?.clients || [],
      groups: data?.groups || [],
      countries: data?.countries || [],
    }
  }
